import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
const root = document.getElementById('root')!
const host = window.location.hostname.toLowerCase()
const applicationHost = /^(apps|control|admin)\.empefy\.com\.br$/.test(host)
  || host === 'app.sanmoriel.com.br'
  || host === 'app.empefy.com.br'
  || host === 'account.sanmoriel.com.br'
  || host === 'account.empefy.com.br'
const landingPath = ['/', '/en-US', '/en-US/', '/es', '/es/'].includes(window.location.pathname)

if (host === 'account.sanmoriel.com.br') document.title = 'Conta San Moriel'

if (!applicationHost) {
  const { initAnalytics } = await import('./lib/analytics')
  initAnalytics()
}

if (!applicationHost && landingPath) {
  // The text and poster are already rendered in production HTML. WebGL is a
  // separate progressive enhancement and never participates in the LCP path.
  const { Landing } = await import('./routes/public/Landing')
  const element = <React.StrictMode><Landing/></React.StrictMode>
  if (root.dataset.empefyPrerender) hydrateRoot(root, element)
  else createRoot(root).render(element)
} else if (host === 'app.sanmoriel.com.br' || host === 'app.empefy.com.br' || (!applicationHost && !['empefy.com.br', 'www.empefy.com.br', 'sanmoriel.com.br', 'www.sanmoriel.com.br'].includes(host) && /^\/app(?:\/|$)/.test(window.location.pathname))) {
  // Authenticated workspace has a scoped style boundary; the public LP keeps its existing bundle.
  const { default: WorkspaceApp } = await import('./workspace/WorkspaceApp')
  createRoot(root).render(<React.StrictMode><WorkspaceApp/></React.StrictMode>)
} else {
  // Preserve all existing application surfaces, routing, auth and styles.
  const [module] = await Promise.all([
    import('./app/App'), import('./styles/tokens.css'), import('./styles/globals.css'),
    import('./styles/components.css'), import('./styles/seo.css'), import('./styles/mobile-language-center.css'),
    import('./styles/account-mobile-action-alignment.css'), import('./styles/system-typography.css'),
    import('./explorerHeaderAdjustment')
  ])
  const App = module.default
  createRoot(root).render(<React.StrictMode><App/></React.StrictMode>)
}
